<script setup lang="ts">
defineProps<{ post: Post }>();
</script>

<template>
  <a :href="post.link" class="group rounded-lg border overflow-hidden shadow-sm transition hover:shadow-xl flex flex-col gap-3 p-3">
    <div class="w-full aspect-video bg-muted rounded-sm">
      <img :src="post.featured_image.src" :alt="post.featured_image.alt" class="size-full object-contain" :style="`object-position: ${post.featured_image.object_position};`">
    </div>
    <div class="h-full">
      <div class="text-muted uppercase">{{ formatWorkshop(post.acf.workshop) }}</div>
      <h3 class="text-level heading-4" v-html="post.title.rendered" />
    </div>
  </a>
</template>
